<!-- eslint-disable vue/valid-v-slot -->
<template>
  <div>
    <v-data-table :headers="headers" :items="desserts" sort-by="ID_Cargador" item-key="ID_Cargador" class="elevation-1 notranslate" translate="no"
      :search="search" :custom-filter="customFilter" dense fixed-header :mobile-breakpoint="600" :dark="$vuetify.theme.dark">
      <template v-slot:top>
        <v-overlay :value="loading">
          <v-progress-circular indeterminate color="primary"></v-progress-circular>
        </v-overlay>
        <v-snackbar v-model="NotiExito" :timeout="3000" color="success" top right>
          <span v-text="notiMessage"></span>
          <template v-slot:action="{ attrs }">
            <v-btn text v-bind="attrs" @click="NotiExito = false">
              Cerrar
            </v-btn>
          </template>
        </v-snackbar>
        <v-snackbar v-model="notiError" :timeout="5000" color="error" top right>
          <span v-text="errorMessage"></span>
          <template v-slot:action="{ attrs }">
            <v-btn text v-bind="attrs" @click="notiError = false">
              Cerrar
            </v-btn>
          </template>
        </v-snackbar>
        <v-snackbar v-model="notiRequerido" :timeout="6000" color="warning" top right>
          <span v-text="msgRequerido"></span>
          <template v-slot:action="{ attrs }">
            <v-btn text v-bind="attrs" @click="notiRequerido = false">
              Cerrar
            </v-btn>
          </template>
        </v-snackbar>
        <div class="table-toolbar">
          <div class="table-toolbar__left">
            <span class="table-toolbar__title">Inscribir</span>
          </div>
          <div class="table-toolbar__right">
            <div class="table-search-wrap">
              <v-icon small color="rgba(255,255,255,0.4)">mdi-magnify</v-icon>
              <input v-model="search" type="text" class="table-search" placeholder="Buscar..." />
            </div>

            <v-dialog v-model="dialog" max-width="500px" :persistent="loading">
              <template v-slot:activator="{ on, attrs }">
                <button class="table-btn table-btn--primary" v-bind="attrs" v-on="on" @click="creacion = true"
                  :disabled="loading">+ Nuevo Cargador</button>
              </template>
              <div class="table-dialog">
                <div class="table-dialog__header">
                  <span class="table-dialog__title">{{ formTitle }}</span>
                </div>
                <div class="table-dialog__body">
                  <v-container>
                    <v-row>
                      <v-col cols="12" sm="6" md="4">
                        <v-text-field v-model="editedItem.Nombre" label="Nombre" @input="validateName" :disabled="editedIndex > -1" dark :rules="[
                          (v) => !!v || 'Nombre es requerido',
                          (v) =>
                            /^[a-zA-ZáéíóúñÁÉÍÓÚ\s]+$/.test(v) ||
                            'Ingrese solo letras en el nombre',
                        ]"></v-text-field>
                      </v-col>
                      <v-col cols="12" sm="6" md="4">
                        <v-text-field v-model="editedItem.Apellido" label="Apellido" @input="validateLastName" :disabled="editedIndex > -1" dark :rules="[
                          (v) => !!v || 'Apellido es requerido',
                          (v) =>
                            /^[a-zA-ZáéíóúñÁÉÍÓÚ\s]+$/.test(v) ||
                            'Ingrese solo letras en el apellido',
                        ]"></v-text-field>
                      </v-col>
                      <v-col cols="12" sm="6" md="4">
                        <v-text-field v-model="editedItem.Altura" label="Altura" @input="validateHeight" dark :rules="[
                          (v) => !!v || 'Altura es requerida',
                          (v) =>
                            /^\d{1,2}(\.\d{1,2})?$/.test(v) ||
                            'Ingrese un número válido de altura',
                        ]"></v-text-field>
                      </v-col>
                      <v-col cols="12" sm="6" md="4" v-if="creacion">
                        <v-menu :close-on-content-click="false" :nudge-right="40" transition="scale-transition" offset-y>
                          <template v-slot:activator="{ on, attrs }">
                            <v-text-field v-model="editedItem.fechaNacimiento" label="Fecha nacimiento" readonly dark
                              v-bind="attrs" v-on="on" :rules="[
                                (v) => !!v || 'Fecha nacimiento es requerido',
                              ]"></v-text-field>
                          </template>
                          <v-date-picker v-model="editedItem.fechaNacimiento" no-title></v-date-picker>
                        </v-menu>
                      </v-col>
                      <v-col cols="12" sm="6" md="4">
                        <v-text-field v-model="editedItem.Direccion" label="Dirección" dark
                          :rules="[(v) => !!v || 'Dirección es requerido']"></v-text-field>
                      </v-col>
                      <v-col cols="12" sm="6" md="4">
                        <v-text-field v-model="editedItem.Telefono" label="Telefono" dark
                          :error-messages="errors.Telefono"></v-text-field>
                      </v-col>
                      <v-col cols="12" sm="6" md="4">
                        <v-text-field v-model="editedItem.Correo" label="Correo" dark
                          :error-messages="errors.Correo"></v-text-field>
                      </v-col>
                      <v-col cols="12" sm="6" md="4">
                        <v-text-field v-model="editedItem.Documento_Identificacion" label="CUI" @input="validateCUI" dark
                          :disabled="editedIndex > -1" :rules="cuiRules"></v-text-field>
                      </v-col>
                      <v-col cols="12" sm="6" md="4" v-if="creacion">
                        <v-checkbox v-model="editedItem.inscrito" label="Inscribir" :true-value="1" dark
                          :false-value="0"></v-checkbox>
                      </v-col>
                      <v-col cols="12" sm="6" md="4" v-if="editedItem.inscrito === 1">
                        <v-select v-model="editedItem.Tipo_cargador" label="Tipo" :items="itemsTipoCarga" dark
                          :rules="[(v) => !!v || 'tipo es requerido']" @change="setOfrenda"></v-select>
                      </v-col>
                      <v-col cols="12" sm="6" md="4" v-if="editedItem.inscrito === 1">
                        <v-text-field v-model="editedItem.Costo_Inscripcion" label="Costo" dark
                          :rules="[(v) => !!v || 'Costo es requerido', (v) => /^[0-9]+(\.[0-9]+)?$/.test(v) || 'Ingrese un número válido']"
                          type="number" step="0.01"></v-text-field>
                      </v-col>
                    </v-row>
                  </v-container>
                </div>
                <div class="table-dialog__actions">
                  <button class="table-btn table-btn--ghost" @click="close" :disabled="loading">Cancelar</button>
                  <button class="table-btn table-btn--primary" @click="save" :disabled="loading || !formValidate">Guardar</button>
                </div>
              </div>
            </v-dialog>

            <v-dialog v-model="dialogDelete" max-width="500px" :persistent="loading">
              <div class="table-dialog">
                <div class="table-dialog__header">
                  <span class="table-dialog__title">⚠️ Confirmar eliminación</span>
                  <p class="table-dialog__sub">¿Estás seguro que deseas eliminar a <strong>{{ editedItem.Nombre }}</strong>?</p>
                </div>
                <div class="table-dialog__actions">
                  <button class="table-btn table-btn--ghost" @click="closeDelete" :disabled="loading">No, cancelar</button>
                  <button class="table-btn table-btn--danger" @click="deleteItemConfirm" :disabled="loading">Sí, eliminar</button>
                </div>
              </div>
            </v-dialog>

            <v-dialog v-model="dialogInscribir" max-width="500px" :persistent="loading">
              <div class="table-dialog">
                <div class="table-dialog__header">
                  <span class="table-dialog__title">Inscribir Cargador</span>
                  <p class="table-dialog__sub">Se inscribirá al Cargador <strong>{{ editedItem.Nombre_Completo }}</strong></p>
                </div>
                <div class="table-dialog__body">
                  <v-container>
                    <v-row>
                      <v-select v-model="editedItem.Tipo_cargador" label="Tipo" :items="itemsTipoCarga" dark
                        :rules="[(v) => !!v || 'tipo es requerido']" @change="setOfrenda"></v-select>
                    </v-row>
                    <v-row>
                      <v-col cols="12" sm="6" md="4">
                        <v-text-field v-model="editedItem.Costo_Inscripcion" label="Costo" dark
                          :rules="[(v) => !!v || 'Costo es requerido', (v) => /^[0-9]+(\.[0-9]+)?$/.test(v) || 'Ingrese un número válido']"
                          type="number" step="0.01"></v-text-field>
                      </v-col>
                    </v-row>
                  </v-container>
                </div>
                <div class="table-dialog__actions">
                  <button class="table-btn table-btn--ghost" @click="closeInscribir" :disabled="loading">Cancelar</button>
                  <button class="table-btn table-btn--primary" @click="InscribirItemConfirm" :disabled="loading">Inscribir</button>
                </div>
              </div>
            </v-dialog>
          </div>
        </div>
      </template>
      <template v-slot:item.ID_Cargador="{ item }"><span v-text="item.ID_Cargador"></span></template>
      <template v-slot:item.Nombre_Completo="{ item }"><span v-text="item.Nombre_Completo"></span></template>
      <template v-slot:item.Altura="{ item }"><span v-text="item.Altura"></span></template>
      <template v-slot:item.Fecha_Inscripcion="{ item }"><span v-text="item.Fecha_Inscripcion"></span></template>
      <template v-slot:item.Documento_Identificacion="{ item }"><span v-text="item.Documento_Identificacion"></span></template>
      <template v-slot:item.Telefono="{ item }"><span v-text="item.Telefono"></span></template>
      <template v-slot:item.Correo="{ item }"><span v-text="item.Correo"></span></template>
      <template v-slot:item.Tipo_cargador="{ item }"><span v-text="item.Tipo_cargador"></span></template>
      <template v-slot:item.Mesa="{ item }"><span v-text="item.Mesa"></span></template>
      <template v-slot:item.No_Recibo="{ item }"><span v-text="item.No_Recibo"></span></template>
      <template v-slot:item.inscribir="{ item }">
        <div class="d-flex justify-center align-center">
          <v-icon small class="mr-2" @click="InscribirItem(item)" color="info"
            v-if="item.inscrito === 0">mdi-plus-circle</v-icon>
        </div>
        <div class="d-flex justify-center align-center">
          <v-icon small class="mr-2" @click="generatePDF2(item)" color="info"
            v-if="item.inscrito === 1">mdi-file-document</v-icon>
          <v-icon small class="mr-2" @click="sendPDF(item)" color="error" v-if="item.inscrito === 1">mdi-gmail</v-icon>
        </div>
      </template>
      <template v-slot:item.actions="{ item }">
        <div class="d-flex justify-center align-center">
          <v-icon small class="mr-2" @click="editItem(item)" color="success">mdi-pencil</v-icon>
          <v-icon small @click="deleteItem(item)" color="error">mdi-delete</v-icon>
        </div>
      </template>
      <template v-slot:no-data>
        <v-btn color="primary" @click="initialize">Reset</v-btn>
      </template>
    </v-data-table>
    <!-- Dialog de sesión expirada -->
    <v-dialog v-model="showSessionExpiredDialog" max-width="400">
      <v-card>
        <v-card-title>¡Sesión expirada!</v-card-title>
        <v-card-text>Tu sesión ha expirado. Por favor, inicia sesión
          nuevamente.</v-card-text>
        <v-card-actions>
          <v-btn color="primary" @click="redirectToLogin">Iniciar sesión</v-btn>
        </v-card-actions>
      </v-card>
    </v-dialog>
  </div>
</template>

<script>
import axios from "axios";

import { PDFDocument } from 'pdf-lib';

export default {
  props: {
    cargadores: [],
  },
  data: () => ({
    datos: {
      nombre: "Juan Pérez",
      fecha: new Date().toLocaleDateString(),
      monto: "Q100",
      descripcion: "Inscripción a la procesión de Semana Santa",
    },
    errors: {},
    itemsTipoCarga: {
      Tipo_cargador: null
    },
    cuiRequerido: "S",
    showSessionExpiredDialog: false,
    dialog: false,
    formValidate: true,
    loading: false,
    dialogDelete: false,
    dialogInscribir: false,
    NotiExito: false,
    notiMessage: "",
    notiRequerido: false,
    msgRequerido: "",
    notiError: false,
    errorMessage: "",
    search: "",
    creacion: false,
    // cuiVisible: false,
    validToken: false,
    inscritoCorrecto: false,
    reciboCorrecto: false,
    headers: [
      {
        text: "CargadorID",
        align: "start",
        sortable: false,
        value: "ID_Cargador",
      },
      //{ text: 'Nombre', value: 'Nombre' },
      //{ text: 'Apellido', value: 'Apellido' },
      { text: "Nombre Completo", value: "Nombre_Completo" }, // Cambio aquí
      { text: "Altura", value: "Altura" },
      { text: "Fecha Inscripción", value: "Fecha_Inscripcion" },
      //   { text: "Dirección", value: "Direccion", sortable: false },
      { text: 'CUI', value: 'Documento_Identificacion' },
      { text: "Telefono", value: "Telefono" },
      { text: "Correo", value: "Correo" },
      { text: "Tipo", value: "Tipo_cargador" },
      { text: "Mesa", value: "Mesa" },
      { text: "No. Recibo", value: "No_Recibo" },
      { text: "Inscribir", value: "inscribir", sortable: false },
      { text: "Actualizar/Eliminar", value: "actions", sortable: false },
    ],
    desserts: [
      {
        ID_Cargador: 1,
        //"Nombre": "Sangría",
        //"Apellido": "Sangría",
        Nombre_Completo: "Sangría Sangría",
        // "Fecha_Nacimiento": "2024-01-01T00:00:00.000Z",
        Altura: "2.00",
        Fecha_Inscripcion: "2024-01-01T00:00:00.000Z",
        Direccion: "0",
        "Documento_Identificacion": "0",
        Estado: "A",
        Telefono: "0",
        Correo: "0",
        Tipo_cargador: "cargador",
        Mesa: 0,
        No_Recibo: 0,
        inscrito: 0,
        Costo_Inscripcion: 0
      },
    ],
    editedIndex: -1,
    editedItem: {
      ID_Cargador: "",
      //Nombre: '',
      //Apellido: '',
      Nombre_Completo: "",
      Altura: "",
      Fecha_Inscripcion: "",
      // fechaNacimiento: '',
      Direccion: "",
      Documento_Identificacion: '',
      Telefono: "",
      Correo: "",
      Tipo_cargador: "",
      Mesa: 0,
      No_Recibo: 0,
      inscrito: "",
      Costo_Inscripcion: 0
    },
    defaultItem: {
      ID_Cargador: "",
      //Nombre: '',
      //Apellido: '',
      Nombre_Completo: "",
      Altura: "",
      Fecha_Inscripcion: "",
      // fechaNacimiento: '',
      Direccion: "",
      Documento_Identificacion: '',
      Telefono: "",
      Correo: "",
      Tipo_cargador: "",
      Mesa: "",
      No_Recibo: "",
      inscrito: "",
      Costo_Inscripcion: ""
    },
  }),

  computed: {
    formTitle() {
      return this.editedIndex === -1 ? "Crear Cargador" : "Editar Cargador";
    },
    cuiRules() {

      const requerido = this.cuiRequerido === 'S';

      return [
        v => (!requerido && !v) || !!v || 'CUI es requerido', // Solo requerido si cuiRequerido es 'S'
        v => (!v || v.length === 13) || 'El CUI debe tener 13 dígitos', // Solo valida si hay algo escrito
        v => (!v || /^\d+$/.test(v)) || 'Ingrese solo números en el CUI' // Solo valida si hay algo escrito
      ];
    }
  },
  watch: {
    dialog(val) {
      val || this.close();
    },
    dialogDelete(val) {
      val || this.closeDelete();
    },
    dialogInscribir(val) {
      val || this.closeInscribir();
    },
    cargadores: {
      handler(newCargadores) {
        if (newCargadores.length > 0) {
          this.initialize();
        }
      },
      deep: true,
    },
    "editedItem.Correo"(newValue, oldValue) {
      // Validar el correo electrónico solo si ha cambiado
      if (newValue !== oldValue) {
        if (this.editedItem.Correo && !/^[^\s@]+@[^\s@]+\.[^\s@]+$/.test(this.editedItem.Correo)) {
          this.errors.Correo = "Ingrese un correo válido";
        } else { this.errors.Correo = "" }

      }
    },
    "editedItem.Telefono"(newValue, oldValue) {
      // Validar el correo electrónico solo si ha cambiado
      if (newValue !== oldValue) {
        if (this.editedItem.Telefono && !/^\d{8}$/.test(this.editedItem.Telefono)) {
          this.errors.Telefono = "Ingrese un número de teléfono válido"
        } else { this.errors.Telefono = "" }
      }
    },
  },
  created() {
    this.initialize();
    this.setTipoTurno();
  },
  methods: {
    setTipoTurno() {
      if (this.$cookies.get('hermandad') === "Virgen de dolores") {
        this.itemsTipoCarga = ["cargador", "aspirante", "honor salida", "honor entrada"];
      } else if (this.$cookies.get('hermandad') === "Jesús Nazareno de la caída") {
        this.itemsTipoCarga = ["cargador", "aspirante", "honor mujeres 1", "honor mujeres 2"];
      } else if (this.$cookies.get('hermandad') === "Hermandad Pruebas") {
        this.itemsTipoCarga = ["cargador", "aspirante", "honor mujeres 1", "honor mujeres 2", "honor salida", "honor entrada", "honor extraordinario"];
      } else if (this.$cookies.get('hermandad') === "Hermandad Virgen de dolores Infantil") {
        this.itemsTipoCarga = ["cargador", "aspirante", "honor salida", "honor entrada", "honor extraordinario"];
      } else {
        this.itemsTipoCarga = ["cargador", "aspirante"];
      }
    },
    setOfrenda() {
      if (this.editedItem.Tipo_cargador === "aspirante") {
        this.editedItem.Costo_Inscripcion = this.$cookies.get('ProcesionACosto') || '';
      } else if (this.editedItem.Tipo_cargador === "cargador") {
        this.editedItem.Costo_Inscripcion = this.$cookies.get('ProcesionCost') || '';
      } else if (this.editedItem.Tipo_cargador === "honor salida" || this.editedItem.Tipo_cargador === "honor mujeres 1") {
        this.editedItem.Costo_Inscripcion = this.$cookies.get('ProcesionSCost') || '';
      } else if (this.editedItem.Tipo_cargador === "honor entrada" || this.editedItem.Tipo_cargador === "honor mujeres 2") {
        this.editedItem.Costo_Inscripcion = this.$cookies.get('ProcesionECost') || '';
      } else if (this.editedItem.Tipo_cargador === "honor extraordinario") {
        this.editedItem.Costo_Inscripcion = '30' || '';
      }
    },
    async RegistraBitacoraRecibo() {
      this.loading = true;

      const apiUrl = `https://wj7gxic747.execute-api.us-east-1.amazonaws.com/dev/api/inscripciones`;
      const token = this.$cookies.get("token");
      const config = {
        headers: {
          Authorization: `Bearer ${token}`,
        },
      };
      const bodyReq = {
        mesa: this.editedItem?.Mesa,
        recibo: this.editedItem?.No_Recibo,
        estatura: this.editedItem?.Altura,
        nombre: this.editedItem?.Nombre_Completo,
        cui: this.editedItem?.Documento_Identificacion,
        codigo_devoto: this.editedItem?.ID_Cargador,
        ofrenda: this.editedItem?.Costo_Inscripcion,
        tipo: this.editedItem?.Tipo_cargador,
        fecha: this.editedItem?.Fecha_Inscripcion,
        usuario: this.$cookies.get("username"),
        procesion: this.$cookies.get("ProcesionID")
      };

      try {
        await axios.put(apiUrl, bodyReq, config);
        this.reciboCorrecto = true;
      } catch (error) {
        this.reciboCorrecto = false;
        
        if (error.response && error.response.status === 422) {
             this.errorMessage = "No se puede generar recibo: " + (error.response.data.error || "La inscripción no existe.");
             // Actualizar estado local
             if (this.editedIndex > -1) {
                this.desserts[this.editedIndex].inscrito = 0;
                this.desserts[this.editedIndex].No_Recibo = null;
                this.desserts[this.editedIndex].Mesa = null;
                this.desserts[this.editedIndex].Tipo_cargador = null;
                this.desserts[this.editedIndex].Fecha_Inscripcion = null;
             }
             // this.initialize(); 
        } else {
             this.errorMessage =
            "Hubo un problema en la generación del recibo, vuelva a intentarlo, " +
            (error.response?.data?.message || error.message);
        }

        this.notiError = true;
        this.hideNotification();
      } finally {
        this.loading = false;
      }
    },
    async generatePDF2(item) {
      if (this.loading) return;

      this.loading = true;
      this.editedIndex = this.desserts.indexOf(item);
      this.editedItem = Object.assign({}, item);

      await this.RegistraBitacoraRecibo();

      if (this.reciboCorrecto != true) {
        this.loading = false;
        return;
      } else {
        this.loading = true;
      }

      const url = `/templates/${this.$cookies.get("templateRecibo")}`;
      const existingpdfBytes = await fetch(url).then(res => res.arrayBuffer());

      const pdfDoc = await PDFDocument.load(existingpdfBytes);

      const form = pdfDoc.getForm();

      form.getTextField('nombre')?.setText(String(this.editedItem?.Nombre_Completo || ' '));
      form.getTextField('fecha')?.setText(String(this.editedItem?.Fecha_Inscripcion || ' '));
      form.getTextField('mesa')?.setText(String(this.editedItem?.Mesa || ' '));
      form.getTextField('estatura')?.setText(String(this.editedItem?.Altura || ' '));
      form.getTextField('codigo')?.setText(String(this.editedItem?.ID_Cargador || ' '));
      form.getTextField('cui')?.setText(String(this.editedItem?.Documento_Identificacion || ' '));
      form.getTextField('recibo')?.setText(String(this.editedItem?.No_Recibo || ' '));
      form.getTextField('tipo')?.setText(String(this.editedItem?.Tipo_cargador || ' '));
      form.getTextField('evento')?.setText(String(this.$cookies.get('Procesion') || ' '));
      form.getTextField('ofrenda')?.setText(`Q${Number(this.editedItem?.Costo_Inscripcion || 0).toFixed(2)}`);
      // const ofrendaField = form.getTextField('ofrenda');

      // if (this.editedItem.Tipo_cargador == "cargador") {
      //   costo = String(this.$cookies.get("ProcesionCost"));
      // } else {
      //   costo = String(this.$cookies.get("ProcesionACosto"));
      // }
      // ofrendaField.setText(costo);


      form.flatten();

      const pdfBytes = await pdfDoc.save();

      this.downloadPDF(pdfBytes);
      this.loading = false;

      this.$nextTick(() => {
        this.editedItem = Object.assign({}, this.defaultItem);
        this.editedIndex = -1;
      });
    },
    downloadPDF(pdfBytes) {
      const blob = new Blob([pdfBytes], { type: 'application/pdf' });
      const url = URL.createObjectURL(blob);


      window.open(url, '_blank');

    },
    async sendPDF(item) {
      if (this.loading) return;
      this.loading = true;
      this.editedIndex = this.desserts.indexOf(item);
      this.editedItem = Object.assign({}, item);




      if (this.editedItem.Correo === "") {
        this.loading = false;
        this.errorMessage = "Error al enviar correo, El cargador no tiene registrado un correo electrónico.";
        this.notiError = true;
        this.hideNotification();
        return;
      }

      await this.RegistraBitacoraRecibo();

      if (this.reciboCorrecto != true) {
        this.loading = false;
        return;
      } else {
        this.loading = true;
      }

      try {

        // Cargar la plantilla PDF
        const url = `/templates/${this.$cookies.get("templateRecibo")}`;
        const existingPdfBytes = await fetch(url).then(res => res.arrayBuffer());
        const pdfDoc = await PDFDocument.load(existingPdfBytes);
        const form = pdfDoc.getForm();



        // Llenar los campos del PDF con los datos del item
        form.getTextField('nombre')?.setText(String(this.editedItem?.Nombre_Completo || ' '));
        form.getTextField('fecha')?.setText(String(this.editedItem?.Fecha_Inscripcion || ' '));
        form.getTextField('mesa')?.setText(String(this.editedItem?.Mesa || ' '));
        form.getTextField('estatura')?.setText(String(this.editedItem?.Altura || ' '));
        form.getTextField('codigo')?.setText(String(this.editedItem?.ID_Cargador || ' '));
        form.getTextField('cui')?.setText(String(this.editedItem?.Documento_Identificacion || ' '));
        form.getTextField('recibo')?.setText(String(this.editedItem?.No_Recibo || ' '));
        form.getTextField('tipo')?.setText(String(this.editedItem?.Tipo_cargador || ' '));
        form.getTextField('evento')?.setText(String(this.$cookies.get('Procesion') || ' '));
        form.getTextField('ofrenda')?.setText(`Q${Number(this.editedItem?.Costo_Inscripcion || 0).toFixed(2)}`);


        // Aplanar el formulario para hacerlo no editable
        form.flatten();

        // Guardar el PDF como bytes
        const pdfBytes = await pdfDoc.save();

        // Convertir el PDF a Base64
        const base64Content = await this.convertToBase64(pdfBytes);

        // Enviar el correo con el PDF adjunto
        await this.sendEmail(base64Content, this.editedItem.Correo, this.editedItem.Nombre_Completo, this.editedItem.ID_Cargador, this.editedItem.No_Recibo, this.editedItem.Mesa);

        this.loading = false;
        this.notiMessage = "Recibo enviado correctamente";
        this.NotiExito = true;
        this.hideNotification();

      } catch (error) {
        console.error("Error al generar/enviar el PDF:", error);
        this.loading = false;
        this.errorMessage = "Error al enviar el recibo";
        this.notiError = true;
        this.hideNotification();
      }

      this.$nextTick(() => {
        this.editedItem = Object.assign({}, this.defaultItem);
        this.editedIndex = -1;
      });

    },
    async convertToBase64(pdfBytes) {
      return new Promise((resolve) => {
        const reader = new FileReader();
        const blob = new Blob([pdfBytes], { type: 'application/pdf' });
        reader.readAsDataURL(blob);
        reader.onloadend = () => resolve(reader.result.split(",")[1]); // Extrae solo el contenido Base64
      });
    },
    async sendEmail(base64Content, email, name, codigo, recibo, mesa) {
      const bodyReq = {
        fromAccount: this.$cookies.get("correoH"),
        to: email,
        subject: "Inscripción",
        templateName: this.$cookies.get("templateRecibo").replace(/\.pdf$/, ""),
        templateData: { name: name, codigo: codigo, recibo: recibo, mesa: mesa },
        attachments: [
          {
            filename: `recibo_${name.replace(" ", "_")}.pdf`,
            base64: base64Content,
          },
        ],
      };

      const token = this.$cookies.get("token");
      const config = {
        headers: {
          Authorization: `Bearer ${token}`,
        },
      };

      const apiUrl = "https://9dxasof85g.execute-api.us-east-1.amazonaws.com/dev/send-email";

      return axios.post(apiUrl, bodyReq, config);
    },
    normalizeText(text) {
      if (!text) return "";
      return text
        .normalize("NFD") // Descompone caracteres acentuados
        .replace(/[\u0300-\u036f]/g, "") // Elimina los acentos
        .toLowerCase(); // Convierte a minúsculas
    },
    customFilter(value, search) {
      if (!value) return false;
      const normalizedValue = this.normalizeText(String(value));
      const normalizedSearch = this.normalizeText(search);
      // Separar los términos de búsqueda por espacios y verificar si todos están en normalizedValue
      const searchTerms = normalizedSearch.split(" ").filter(term => term.trim() !== "");
      return searchTerms.every(term => normalizedValue.includes(term));
    },
    redirectToLogin() {
      const allCookies = this.$cookies.keys();
      for (const cookie of allCookies) {
        this.$cookies.remove(cookie);
      }

      // Redirigir al usuario al componente de inicio de sesión
      this.$router.push("/sistema");
    },
    validateName() {
      const regex = /^[a-zA-ZáéíóúñÁÉÍÓÚ\s]+$/;
      if (!regex.test(this.editedItem.Nombre)) {
        this.editedItem.Nombre = this.editedItem.Nombre.slice(0, -1);
        this.formValidate = false;
      } else {
        this.formValidate = true;
      }
    },
    validateLastName() {
      const regex = /^[a-zA-ZáéíóúñÁÉÍÓÚ\s]+$/;
      if (!regex.test(this.editedItem.Apellido)) {
        this.editedItem.Apellido = this.editedItem.Apellido.slice(0, -1);
        this.formValidate = false;
      } else {
        this.formValidate = true;
      }
    },
    validateHeight() {
      const regex = /^\d{1,2}(\.\d{1,2})?$/;
      if (!regex.test(this.editedItem.Altura)) {
        this.editedItem.Altura = this.editedItem.Altura.slice(0, -1);
        this.formValidate = false;
      } else {
        this.formValidate = true;
      }
    },
    validatePhoneNumber() {
      const regex = /^\d{0,8}$/;
      if (!regex.test(this.editedItem.Telefono)) {
        this.editedItem.Telefono = this.editedItem.Telefono.slice(0, -1);
        this.formValidate = false;
      } else {
        this.formValidate = true;
      }
    },
    validateEmail() {
      const regex = /^[^\s@]+@[^\s@]+\.[^\s@]+$/;
      if (!regex.test(this.editedItem.Correo)) {
        this.editedItem.Correo = this.editedItem.Correo.slice(0, -1);
        this.formValidate = false;
      } else {
        this.formValidate = true;
      }
    },
    // validateCUI() {
    //   const regex = /^\d+$/;
    //   let valor = this.editedItem.Documento_Identificacion;

    //   // Si el valor no es numérico, eliminar caracteres no numéricos
    //   if (!regex.test(valor)) {
    //     this.editedItem.Documento_Identificacion = valor.replace(/\D/g, '');
    //   }

    //   // Validar longitud máxima de 12 dígitos
    //   if (valor.length > 13) {
    //     this.editedItem.Documento_Identificacion = valor.slice(0, 13);
    //   }

    //   // Validación del formulario
    //   this.formValidate = this.editedItem.Documento_Identificacion.length === 13;
    // },
    validateCUI() {
      const regex = /^\d+$/;
      let valor = this.editedItem.Documento_Identificacion || '';

      // Si el valor no es numérico, eliminar caracteres no numéricos
      if (!regex.test(valor)) {
        this.editedItem.Documento_Identificacion = valor.replace(/\D/g, '');
      }

      // Validar longitud máxima de 12 dígitos
      if (valor.length > 13) {
        this.editedItem.Documento_Identificacion = valor.slice(0, 13);
      }

      // Si CUI es requerido, valida la longitud, si no, permite vacío
      if (this.cuiRequerido === 'S') {
        this.formValidate = this.editedItem.Documento_Identificacion.length === 13;
      } else {
        this.formValidate = this.editedItem.Documento_Identificacion.length === 13 || this.editedItem.Documento_Identificacion === '';
      }
    },

    hideNotification() {
      // Logic handled by v-snackbar automatically now
    },
    initialize() {
      this.validateToken();
      this.desserts = this.cargadores;
      this.cuiRequerido = this.$cookies.get('cuiReq')
    },

    editItem(item) {
      this.editedIndex = this.desserts.indexOf(item);
      this.editedItem = Object.assign({}, item);
      this.dialog = true;
      // if (this.editedItem.Documento_Identificacion.length < 13) {
      //   this.cuiVisible = true
      // }
    },

    deleteItem(item) {
      this.editedIndex = this.desserts.indexOf(item);
      this.editedItem = Object.assign({}, item);
      this.dialogDelete = true;
    },
    InscribirItem(item) {
      this.editedIndex = this.desserts.indexOf(item);
      this.editedItem = Object.assign({}, item);
      this.dialogInscribir = true;
    },

    async deleteItemConfirm() {
      // this.desserts.splice(this.editedIndex, 1);
      await this.OrquestaEliminacion();
      this.closeDelete();
    },
    async InscribirItemConfirm() {
      if (
        this.editedItem.Tipo_cargador === null ||
        this.editedItem.Tipo_cargador === undefined
      ) {
        this.loading = false;
        return;
      }

      await this.OrquestaInscripción();

      this.closeInscribir();
    },
    closeInscribir() {
      this.dialogInscribir = false;
      this.creacion = false;

      this.$nextTick(() => {
        this.editedItem = Object.assign({}, this.defaultItem);
        this.editedIndex = -1;
      });
    },
    close() {
      this.dialog = false;
      this.creacion = false;

      this.$nextTick(() => {
        this.editedItem = Object.assign({}, this.defaultItem);
        this.editedIndex = -1;
      });
    },

    closeDelete() {
      this.dialogDelete = false;
      this.$nextTick(() => {
        this.editedItem = Object.assign({}, this.defaultItem);
        this.editedIndex = -1;
      });
    },

    async save() {
      this.errors = {};//Reiniciar errores antes de validar
      this.msgRequerido = "";
      this.notiRequerido = false;
      this.validaReq();


      if (this.editedItem.Telefono && !/^\d{8}$/.test(this.editedItem.Telefono)) {
        this.errors.Telefono = "Ingrese un número de teléfono válido"
      }

      if (this.editedItem.Correo && !/^[^\s@]+@[^\s@]+\.[^\s@]+$/.test(this.editedItem.Correo)) {
        this.errors.Correo = "Ingrese un correo válido";
      }

      if (this.notiRequerido || Object.keys(this.errors).length > 0) {
        // this.creacion = false
        return;
      }

      try {
        if (this.editedIndex > -1) {
          // Object.assign(this.desserts[this.editedIndex], this.editedItem);
          await this.ActualizaCargador();
        } else {
          await this.creaCargador();
          // this.desserts.push(this.editedItem)
        }
        // this.close();
      } catch (error) {
        // this.errorMessage = "Hubo un problema al guardar ";
        this.notiError = true;
        this.hideNotification();
        // this.loading = false;
      }
    },
    validaReq() {
      this.msgRequerido = "Los campos ";
      if (!this.editedItem.Nombre) {
        this.notiRequerido = true;
        this.msgRequerido = this.msgRequerido + "Nombre";
      }
      if (!this.editedItem.Apellido) {
        this.notiRequerido = true;
        this.msgRequerido = this.msgRequerido + ", Apellido";
      }
      if (!this.editedItem.Altura) {
        this.notiRequerido = true;
        this.msgRequerido = this.msgRequerido + ", Altura";
      }
      if (!this.editedItem.fechaNacimiento && this.creacion) {
        this.notiRequerido = true;
        this.msgRequerido = this.msgRequerido + ", Fecha nacimiento";
      }
      if (!this.editedItem.Direccion) {
        this.notiRequerido = true;
        this.msgRequerido = this.msgRequerido + ", Dirección";
      }
      if (this.cuiRequerido === 'S' && !this.editedItem.Documento_Identificacion) {
        this.notiRequerido = true;
        this.msgRequerido = this.msgRequerido + ", CUI";
      }

      if (!this.editedItem.Tipo_cargador && this.editedItem.inscrito === 1) {
        this.notiRequerido = true;
        this.msgRequerido = this.msgRequerido + ", Tipo de cargador";
      }
      if (!this.editedItem.Costo_Inscripcion && this.editedItem.inscrito === 1) {
        this.notiRequerido = true;
        this.msgRequerido = this.msgRequerido + ", Costo";
      }
      this.msgRequerido = this.msgRequerido + " son requeridos.";
    },
    async OrquestaEliminacion() {
      this.loading = true;
      await this.validateToken();
      if (!this.validToken) {
        // localStorage.clear
        this.clearAllCookies();
        return;
      }
      const token = this.$cookies.get("token");
      const config = {
        headers: {
          Authorization: `Bearer ${token}`,
        },
      };

      const idCargador = this.editedItem.ID_Cargador;

      // await this.EliminaCargador(idCargador, config);

      await this.EliminaInscripcion(idCargador, config);
      this.loading = false;
    },
    async OrquestaInscripción() {
      this.inscritoCorrecto = false
      this.loading = true;
      await this.validateToken();
      if (!this.validToken) {
        this.clearAllCookies();
        return;
      }
      // Obtener la fecha actual
      const now = new Date();

      // Formatear la fecha en el formato deseado: DD/MM/YYYY HH:mm
      const formattedDate = `${String(now.getDate()).padStart(2, "0")}/${String(
        now.getMonth() + 1
      ).padStart(2, "0")}/${now.getFullYear()}`;
      const token = this.$cookies.get("token");
      const config = {
        headers: {
          Authorization: `Bearer ${token}`,
        },
      };

      const bodyReq = {
        nuevo_id_cargador: this.editedItem.ID_Cargador,
        nuevo_id_procesion: this.$cookies.get("ProcesionID"),
        tipo_cargador: this.editedItem.Tipo_cargador,
        usuario_responsable: this.$cookies.get("username"), //localStorage.username
        costo: this.editedItem.Costo_Inscripcion
      };

      await this.InscribeCargador(bodyReq, config);

      if (this.inscritoCorrecto == true && this.editedIndex > -1) {
        this.desserts[this.editedIndex].inscrito = 1; // Actualiza localmente
        this.desserts[this.editedIndex].Tipo_cargador =
          this.editedItem.Tipo_cargador;
        this.desserts[this.editedIndex].Fecha_Inscripcion = formattedDate;
        this.desserts[this.editedIndex].Mesa = this.editedItem.Mesa;
        this.desserts[this.editedIndex].No_Recibo = this.editedItem.No_Recibo;
        this.desserts[this.editedIndex].Costo_Inscripcion = this.editedItem.Costo_Inscripcion;
      }
      this.loading = false;
    },
    InscribeCargador(bodyReq, config) {
      const apiUrl = "https://wj7gxic747.execute-api.us-east-1.amazonaws.com/dev/api/inscripciones";

      // const apiUrl = "http://localhost:3000/dev/api/inscripciones";

      // Enviar la solicitud para crear un nuevo cargador
      return axios
        .post(apiUrl, bodyReq, config)
        .then((response) => {
          // this.loading = false;

          this.editedItem.Mesa = response.data.mesa;
          this.editedItem.No_Recibo = response.data.noRecibo;
          if (response.data.tipoCargador) {
             this.editedItem.Tipo_cargador = response.data.tipoCargador;
          }

          this.notiMessage = "El cargador ha sido inscrito correctamente";
          this.NotiExito = true;
          this.hideNotification();
          this.inscritoCorrecto = true;
        })
        .catch((error) => {
          this.inscritoCorrecto = false;
          // Verificar si el error proviene del backend y tiene un mensaje específico
          if (error.response && error.response.data && error.response.data.error) {
            this.errorMessage = error.response.data.error; // Mensaje del SP
          } else {

            this.errorMessage =
              "Hubo un problema en la inscripción del cargador, ";
          }
          this.notiError = true;
          this.hideNotification();
          // this.loading = false;
        });
    },
    clearAllCookies() {
      const allCookies = this.$cookies.keys();
      for (const cookie of allCookies) {
        this.$cookies.remove(cookie);
      }
    },
    EliminaCargador(idCargador, config) {
      // const idCargador = this.editedItem.ID_Cargador
      // this.loading = true;

      const apiUrl = `https://62jecp6v6f.execute-api.us-east-1.amazonaws.com/dev/api/cargadores/${idCargador}?usuarioResponsable=${this.$cookies.get(
        "username"
      )}`;

      return axios
        .delete(apiUrl, config)
        .then(() => {
          // this.loading = false;
          this.notiMessage = "El cargador ha sido eliminado correctamente";
          this.NotiExito = true;
        })
        .catch(() => {
          this.errorMessage =
            "Hubo un problema en la eliminación del cargador, ";
          this.notiError = true;
          this.hideNotification();
          // this.loading = false;
        });
    },
    EliminaInscripcion(idCargador, config) {
      this.loading = true;

      const usr = this.$cookies.get("username");
      const proc = this.$cookies.get("ProcesionID");
      const apiUrl = `https://wj7gxic747.execute-api.us-east-1.amazonaws.com/dev/api/inscripciones/${idCargador}?usr=${usr}&proc=${proc}`;

      return axios
        .delete(apiUrl, config)
        .then(() => {
          this.loading = false;
          this.notiMessage = "La inscripción ha sido eliminada correctamente";
          this.NotiExito = true;

          //Actualización local
          if (this.editedIndex > -1) {
            this.desserts[this.editedIndex].inscrito = 0; // Actualiza localmente
            this.desserts[this.editedIndex].Tipo_cargador = "";
            this.desserts[this.editedIndex].Fecha_Inscripcion = "";
            this.desserts[this.editedIndex].Mesa = "";
            this.desserts[this.editedIndex].No_Recibo = "";
          }
        })
        .catch((error) => {
          if (error.response && error.response.status === 422) {
             this.errorMessage = error.response.data.error;
          } else {
             this.errorMessage = "Hubo un problema en la eliminación de la inscripción.";
          }
          this.notiError = true;
          this.hideNotification();
          this.loading = false;
        });
    },
    async creaCargador() {
      this.loading = true;
      await this.validateToken();

      if (!this.validToken) {
        this.clearAllCookies();
        return;
      }
      const inscribir = this.editedItem.inscrito;

      const token = this.$cookies.get("token");
      const config = {
        headers: {
          Authorization: `Bearer ${token}`,
        },
      };

      const bodyReq = {
        nombre: this.editedItem.Nombre,
        apellido: this.editedItem.Apellido,
        fechaNacimiento: this.editedItem.fechaNacimiento,
        altura: this.editedItem.Altura,
        direccion: this.editedItem.Direccion,
        documentoIdentificacion: this.editedItem.Documento_Identificacion,
        telefono: this.editedItem.Telefono,
        correo: this.editedItem.Correo,
        sexo: "M",
        usuarioResponsable: this.$cookies.get("username"), //localStorage.username
      };
      const apiUrl =
        "https://62jecp6v6f.execute-api.us-east-1.amazonaws.com/dev/api/cargadores";

      // Enviar la solicitud para crear un nuevo cargador

      return axios
        .post(apiUrl, bodyReq, config)
        .then((response) => {
          this.editedItem.ID_Cargador = response.data.cargadorId;
          this.editedItem.Fecha_Registro = response.data.fechaRegistro;
          this.editedItem.inscrito = 0;
          this.editedItem.Nombre_Completo =
            this.editedItem.Nombre + " " + this.editedItem.Apellido;
          //   this.desserts.push(this.editedItem);

          // this.loading = false;
          // this.notiMessage = "El cargador ha sido creado correctamente"
          // this.NotiExito = true
          this.hideNotification();

          if (
            inscribir === null ||
            inscribir === undefined ||
            inscribir === 0 ||
            inscribir === ""
          ) {
            this.desserts.push(this.editedItem);
            this.close();
          }

          if (inscribir === 1) {
            const inscripcionUrl = "https://wj7gxic747.execute-api.us-east-1.amazonaws.com/dev/api/inscripciones";
            // const inscripcionUrl = "http://localhost:3000/dev/api/inscripciones";
            const bodyReqInscripcion = {
              nuevo_id_cargador: this.editedItem.ID_Cargador,
              nuevo_id_procesion: this.$cookies.get("ProcesionID"),
              usuario_responsable: this.$cookies.get("username"), //localStorage.username,
              tipo_cargador: this.editedItem.Tipo_cargador,
              costo: this.editedItem.Costo_Inscripcion
            };

            // Obtener la fecha actual
            const now = new Date();

            // Formatear la fecha en el formato deseado: DD/MM/YYYY HH:mm
            const formattedDate = `${String(now.getDate()).padStart(
              2,
              "0"
            )}/${String(now.getMonth() + 1).padStart(
              2,
              "0"
            )}/${now.getFullYear()}`;

            return axios
              .post(inscripcionUrl, bodyReqInscripcion, config)
              .then((response) => {
                this.editedItem.Fecha_Inscripcion = formattedDate;
                this.editedItem.inscrito = 1;
                this.editedItem.Mesa = response.data.mesa;
                this.editedItem.No_Recibo = response.data.noRecibo;
                if (response.data.tipoCargador) {
                   this.editedItem.Tipo_cargador = response.data.tipoCargador;
                }
                this.desserts.push(this.editedItem);
                this.loading = false;
                this.notiMessage = "El cargador ha sido creado correctamente";
                this.NotiExito = true;
                this.hideNotification();
                this.close();
              })
              .catch((error) => {
                this.loading = false;
                this.editedItem.Fecha_Inscripcion = "";
                this.editedItem.inscrito = 0;
                this.editedItem.Mesa = "";
                this.editedItem.No_Recibo = "";
                this.editedItem.Tipo_cargador = "";
                this.desserts.push(this.editedItem);
                this.close();
                // Verificar si el error proviene del backend y tiene un mensaje específico
                if (error.response && error.response.data && error.response.data.error) {
                  this.errorMessage = error.response.data.error + " El Cargador fue creado pero no inscrito."; // Mensaje del SP
                  this.msgRequerido = error.response.data.error + " El Cargador fue creado pero no inscrito."; // Mensaje del SP
                } else {

                  this.errorMessage =
                    "Hubo un problema en la actualización del cargador, ";

                  this.msgRequerido =
                    "Hubo un problema en la actualización del cargador,";
                }
                this.notiError = true;
                this.notiRequerido = true;
                this.hideNotification();
              });
          } else {
            this.loading = false;
            this.notiMessage = "El cargador ha sido creado correctamente";
            this.NotiExito = true;
            this.hideNotification();
            this.close();
          }
        })
        .catch((error) => {
          this.loading = false;
          this.close();
          this.errorMessage = error.response.data.message;
          this.notiError = true;
          this.msgRequerido = error.response.data.message;
          this.notiRequerido = true;
          this.hideNotification();
          throw error;

        });
    },
    validateToken() {
      // const token = localStorage.token
      const token = this.$cookies.get("token");
      // this.loading = true;
      const apiUrl = `https://wm1xvvtarj.execute-api.us-east-1.amazonaws.com/dev/validateToken?token=${token}`;
      // Configuración para la solicitud GET con el token en el encabezado Authorization

      // Realizar solicitud GET a la API original con el token en el encabezado
      return axios
        .get(apiUrl)
        .then((response) => {
          const username = response.data.decoded.username;
          this.$cookies.set("username", username, "1d", "", "", true, "Strict");

          // localStorage.username = response.data.decoded.username;
          this.validToken = true;
          // this.loading = false; // Desactivar animación de carga
        })
        .catch(() => {
          this.validToken = false;
          this.showSessionExpiredDialog = true;
        });
    },
    async ActualizaCargador() {
      this.loading = true;
      const idCargador = this.editedItem.ID_Cargador;
      const inscrito = this.editedItem.inscrito;
      await this.validateToken();
      if (!this.validToken) {
        // localStorage.clear
        this.clearAllCookies();
        return;
      }
      const apiUrl = `https://62jecp6v6f.execute-api.us-east-1.amazonaws.com/dev/api/cargadores/${idCargador}`;
      const token = this.$cookies.get("token");
      const config = {
        headers: {
          Authorization: `Bearer ${token}`,
        },
      };
      const bodyReq = {
        nombre: this.editedItem.Nombre,
        apellido: this.editedItem.Apellido,
        fechaNacimiento: this.editedItem.fechaNacimiento,
        altura: this.editedItem.Altura,
        direccion: this.editedItem.Direccion,
        telefono: this.editedItem.Telefono,
        correo: this.editedItem.Correo,
        usuarioResponsable: this.$cookies.get("username"), //localStorage.username
        documentoIdentificacion: this.editedItem.Documento_Identificacion
      };
      const tipoCargador = this.editedItem.Tipo_cargador;
      const costo = this.editedItem.Costo_Inscripcion;

      axios
        .put(apiUrl, bodyReq, config)
        .then(() => {
          // this.notiMessage = "El cargador ha sido actualizado correctamente"
          // this.loading = false;
          // this.NotiExito = true
          // this.hideNotification();

          // this.cuiVisible = false;


          if (inscrito == 1) {
            // const idCargador = this.editedItem.ID_Cargador
            this.loading = true;
            // const inscripcionUrl = `http://localhost:3000/dev/api/inscripciones/${idCargador}`;
            const inscripcionUrl = `https://wj7gxic747.execute-api.us-east-1.amazonaws.com/dev/api/inscripciones/${idCargador}`;
            const bodyReqInscripcion = {
              usuario_responsable: this.$cookies.get("username"), //localStorage.username,
              tipo_cargador: tipoCargador,
              nuevo_id_procesion: this.$cookies.get("ProcesionID"),
              costo: costo
            };

            return axios
              .put(inscripcionUrl, bodyReqInscripcion, config)
              .then(() => {
                this.editedItem.Nombre_Completo = this.editedItem.Nombre + " " + this.editedItem.Apellido

                if (this.editedIndex > -1) {
                  Object.assign(this.desserts[this.editedIndex], this.editedItem);
                }
                this.loading = false;
                this.notiMessage =
                  "El cargador ha sido actualizado correctamente";
                this.NotiExito = true;
                this.hideNotification();
                this.close();
              })
              .catch((error) => {


                this.loading = false;


                // this.editedItem.Tipo_cargador = this.desserts[this.editedIndex].Tipo_cargador;
                // this.editedItem.Costo_Inscripcion = this.desserts[this.editedIndex].Costo_Inscripcion;
                // Object.assign(this.desserts[this.editedIndex], this.editedItem);
                // Verificar si el error proviene del backend y tiene un mensaje específico

                if (error.response && error.response.data && error.response.data.error) {
                  this.errorMessage = error.response.data.error; // Mensaje del SP
                  this.msgRequerido = error.response.data.error; // Mensaje del SP
                } else if (error.message) {
                  // Si error.response no está definido, pero error.message sí, mostrar mensaje genérico
                  this.errorMessage = `Hubo un problema: ${error.message}`;
                  this.msgRequerido = `Hubo un problema: ${error.message}`;
                } else {

                  this.errorMessage =
                    "Hubo un problema en la actualización del cargador, ";

                  this.msgRequerido =
                    "Hubo un problema en la actualización del cargador,";
                }
                this.notiError = true;
                this.notiRequerido = true;
                this.hideNotification();
                this.close();
              });
          } else {
            if (this.editedIndex > -1) {
              Object.assign(this.desserts[this.editedIndex], this.editedItem);
            }
            this.loading = false;
            this.notiMessage = "El cargador ha sido actualizado correctamente";
            this.NotiExito = true;
            this.hideNotification();
            this.close();
          }
        })
        .catch((error) => {
          this.loading = false;
          // if (error.response.data.Message = "User is not authorized to access this resource with an explicit deny") {
          //     this.$router.push('/sistema');
          // }

          this.errorMessage =
            "Hubo un problema en la actualización del cargador, " +
            error.response.data.message;
          this.notiError = true;
          this.msgRequerido =
            "Hubo un problema en la actualización del cargador, " +
            error.response.data.message;
          this.notiRequerido = true;
          this.hideNotification();
          this.close();
        });
    },
  },
};
</script>

<style scoped>
/* ── Toolbar dark ── */
.table-toolbar {
  display: flex;
  align-items: center;
  justify-content: space-between;
  flex-wrap: wrap;
  gap: 12px;
  padding: 16px 20px;
  background: var(--sys-card-bg);
  border-bottom: 1px solid var(--sys-card-border);
  font-family: 'Inter', sans-serif;
}
.table-toolbar__title {
  font-size: 1.05rem;
  font-weight: 700;
  color: var(--sys-text-primary);
}
.table-toolbar__right {
  display: flex;
  align-items: center;
  gap: 12px;
  flex-wrap: wrap;
}

/* Search input */
.table-search-wrap {
  display: flex;
  align-items: center;
  gap: 8px;
  background: var(--sys-input-bg);
  border: 1px solid var(--sys-card-border);
  border-radius: 8px;
  padding: 7px 14px;
  transition: border-color 0.2s;
}
.table-search-wrap:focus-within { border-color: rgba(123,47,247,0.6); }
.table-search {
  background: transparent;
  border: none;
  outline: none;
  color: var(--sys-text-primary);
  font-family: 'Inter', sans-serif;
  font-size: 0.88rem;
  width: 160px;
}
.table-search::placeholder { color: var(--sys-text-secondary); }

/* Buttons */
.table-btn {
  padding: 8px 18px;
  border-radius: 8px;
  font-family: 'Inter', sans-serif;
  font-size: 0.85rem;
  font-weight: 600;
  cursor: pointer;
  transition: all 0.2s;
  border: none;
  white-space: nowrap;
}
.table-btn--primary {
  background: linear-gradient(135deg, #7b2ff7, #4a1b9a);
  color: #fff;
  box-shadow: 0 4px 14px rgba(123,47,247,0.3);
}
.table-btn--primary:hover:not(:disabled) {
  transform: translateY(-1px);
  box-shadow: 0 6px 20px rgba(123,47,247,0.5);
}
.table-btn--primary:disabled { opacity: 0.5; cursor: not-allowed; }
.table-btn--ghost {
  background: transparent;
  color: var(--sys-text-secondary);
  border: 1px solid var(--sys-card-border);
}
.table-btn--ghost:hover { background: var(--sys-input-bg); color: var(--sys-text-primary); }
.table-btn--danger {
  background: rgba(239,68,68,0.15);
  color: #fca5a5;
  border: 1px solid rgba(239,68,68,0.3);
}
.table-btn--danger:hover { background: rgba(239,68,68,0.25); }

/* Dialog */
.table-dialog {
  background: var(--sys-dialog-bg);
  border: 1px solid var(--sys-card-border);
  border-radius: 18px;
  padding: 28px 24px;
  font-family: 'Inter', sans-serif;
}
.table-dialog__header { margin-bottom: 20px; }
.table-dialog__title {
  font-size: 1.15rem;
  font-weight: 800;
  color: var(--sys-text-primary);
  display: block;
  margin-bottom: 6px;
}
.table-dialog__sub {
  font-size: 0.9rem;
  color: var(--sys-text-secondary);
  margin: 0;
}
.table-dialog__body { margin-bottom: 24px; }
.table-dialog__actions {
  display: flex;
  justify-content: flex-end;
  gap: 12px;
  padding-top: 16px;
  border-top: 1px solid rgba(123,47,247,0.12);
}

/* Inputs del form en el dialog (Vuetify dark override) */
[data-theme="dark"] ::v-deep .table-dialog .v-input__slot {
  background: rgba(255,255,255,0.05) !important;
}
::v-deep .table-dialog .v-label {
  color: var(--sys-text-secondary) !important;
}
::v-deep .table-dialog input,
::v-deep .table-dialog .v-select__selection {
  color: var(--sys-text-primary) !important;
}
::v-deep .v-checkbox .v-label {
  color: var(--sys-text-primary) !important;
}
</style>

<style scoped>
/* Elimina la clase .custom-table para permitir el funcionamiento fluido de Vuetify */
</style>